function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const React = require('react');

function SvgAudienceManagerColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1152 1152"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#6390FF",
    d: "M0 576c0 318.1 257.9 576 576 576s576-257.9 576-576S894.1 0 576 0 0 257.9 0 576zm59.4 0C59.4 290.3 290.7 58.8 576 58.8s516.6 231.6 516.6 517.2-231.3 517.2-516.6 517.2S59.4 861.7 59.4 576z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAE4FF",
    d: "M826.5 324.3c-73.9-73.9-161.2-90.9-165-91.6l-3.2 11.5c-107.1-24.7-223.9 3.9-308.1 85.6l-12-12c-138.4 138.4-140.4 363.1-3.6 499.9s361 135 499.7-3.7l-11.8-11.8c82.3-84.7 110.7-202.6 85.2-310.3l11.5-3.1c-1-3.7-19.8-91.5-92.7-164.5zM595.4 556.7l72.6-279c27.7 8.4 82.7 29.7 129.1 76.1 45.9 45.9 67.8 100.7 76.6 128.3l-278.3 74.6zm57.8-294.9l-79.9 291.3-210.4-210.3c79.4-77 189.4-103.9 290.3-81zm130.9 527.9c-119 105.9-300.6 103.6-412.9-8.7-112.2-112.3-114.5-294.3-8.8-413.1l421.7 421.8zm25.4-.4L599 578.8l291-82.1c23.8 101.5-3 212.6-80.5 292.6z"
  }));
}

module.exports = React.memo(SvgAudienceManagerColor);